import React, { useState, useEffect } from "react";
import Navigation from "../../../components/Navigation/Navigation";
import axios from "axios";
import Grid from "@mui/material/Grid2";
import {
  Card,
  Box,
  Typography,
  FormControl,
  TextField,
  Button,
  Select,
  MenuItem,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  Paper,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Snackbar,
  Alert,
  InputLabel,
} from "@mui/material";
import { API_ENDPOINTS } from "../../../config/api";
import { useAppSettings } from "../../../context/AppSettingsContext";
import "./EnquiryNow.css";
import { useNavigate } from "react-router-dom";
import FrontendFooter from "../../../components/Layout/FrontendFooter";
const EnquiryNow = () => {
  const [appUsers, setAppUsers] = useState([]);
  const [products, setProducts] = useState([]);
  const { deliveryConditions, deliveryDate } = useAppSettings();
  const [paymentTerms, setPaymentTerms] = useState([]);
  const [deliveryTerms, setDeliveryTerms] = useState([]);
  const [brands, setBrands] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [formData, setFormData] = useState({
    app_user_id: "",
    payment_terms: "",
    payment_terms_description: "",
    delivery_title: "",
    delivery_address: "",
    delivery_conditions: "",
    delivery_date: "",
    delivery_date_hours: "",
    delivery_date_days: "",
    company_name: "",
    
  
    mobile: "",
    subject: "",
    message: "",
    status: "pending",
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error",
  });
  const navigate = useNavigate();
  // Transform delivery conditions string into array of objects
  const deliveryConditionsOptions = React.useMemo(() => {
    if (!deliveryConditions) return [];
    return deliveryConditions
      .split(",")
      .map((condition, index) => ({
        id: `${index + 1}`,
        name: condition.trim(),
      }))
      .filter((condition) => condition.name);
  }, [deliveryConditions]);
  // Transform delivery date string into array of objects
  const deliveryDateOptions = React.useMemo(() => {
    if (!deliveryDate) return [];
    return deliveryDate
      .split(",")
      .map((condition, index) => ({
        id: `${index + 1}`,
        name: condition.trim(),
      }))
      .filter((condition) => condition.name);
  }, [deliveryDate]);
  // Fetch data from APIs
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [usersRes, productsRes, paymentRes, deliveryRes, brandsRes] = await Promise.all([
          axios.get(API_ENDPOINTS.APP_USER_NAMES),
          axios.get(API_ENDPOINTS.PRODUCT_TYPE_NAMES),
          axios.get(API_ENDPOINTS.PAYMENT_TERM_NAMES),
          axios.get(API_ENDPOINTS.DELIVERY_TERM_NAMES),
          axios.get(API_ENDPOINTS.BRAND_NAMES),
        ]);
        setAppUsers(Array.isArray(usersRes.data) ? usersRes.data : usersRes.data.data || []);
        setProducts(
          (Array.isArray(productsRes.data) ? productsRes.data : productsRes.data || []).map(
            (product) => ({
              id: product.id,
              product_name: product.product_name || product.name,
              selected: false,
              brand: "",
              quantity: "",
              pieces: "",
            })
          )
        );
        setPaymentTerms(
          Array.isArray(paymentRes.data.paymentTerms)
            ? paymentRes.data.paymentTerms
            : paymentRes.data || []
        );
        setDeliveryTerms(
          Array.isArray(deliveryRes.data.deliveryTerms)
            ? deliveryRes.data.deliveryTerms
            : deliveryRes.data || []
        );
        setBrands(
          Array.isArray(brandsRes.data) ? brandsRes.data : brandsRes.data.brands || []
        );
      } catch (error) {
        setAppUsers([]);
        setProducts([]);
        setPaymentTerms([]);
        setDeliveryTerms([]);
        setBrands([]);
        setSnackbar({
          open: true,
          message: "Failed to fetch data. Please try again.",
          severity: "error",
        });
      }
    };
    fetchData();
  }, []);
  // Handle form field changes
  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    let newValue = value;
    if (name === "mobile") {
      newValue = value.replace(/\D/g, "").slice(0, 10);
    }
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : newValue,
    }));
  };
  // Handle product selection
  const handleProductSelection = (productId) => {
    setProducts((prevProducts) =>
      prevProducts.map((product) =>
        product.id === productId
          ? { ...product, selected: !product.selected }
          : product
      )
    );
    setSelectedProducts((prevSelected) => {
      const product = products.find((p) => p.id === productId);
      if (!product) return prevSelected;
      if (product.selected) {
        return prevSelected.filter((p) => p.id !== productId);
      } else {
        return [
          ...prevSelected,
          {
            id: product.id,
            name: product.product_name,
            brand: product.brand,
            quantity: product.quantity,
            pieces: product.pieces,
          },
        ];
      }
    });
  };
  // Handle product field changes (quantity, pieces, brand)
  const handleProductFieldChange = (productId, field, value) => {
    const sanitizedValue =
      field === "quantity" || field === "pieces"
        ? value === "" || Number(value) >= 0
          ? value
          : ""
        : value;
    setProducts((prevProducts) =>
      prevProducts.map((product) =>
        product.id === productId
          ? {
            ...product,
            quantity: field === "quantity" ? sanitizedValue : field === "pieces" ? "" : product.quantity,
            pieces: field === "pieces" ? sanitizedValue : field === "quantity" ? "" : product.pieces,
            brand: field === "brand" ? value : product.brand,
          }
          : product
      )
    );
    setSelectedProducts((prevSelected) =>
      prevSelected.map((selected) =>
        selected.id === productId
          ? {
            ...selected,
            quantity: field === "quantity" ? sanitizedValue : field === "pieces" ? "" : selected.quantity,
            pieces: field === "pieces" ? sanitizedValue : field === "quantity" ? "" : selected.pieces,
            brand: field === "brand" ? value : selected.brand,
          }
          : selected
      )
    );
  };
  // Validate form data
  const validateForm = () => {
    const errors = [];
    if (!formData.company_name || !formData.company_name.trim()) {
      errors.push("Company Name is required.");
    }
    
    if (!formData.mobile) {
      errors.push("Mobile Number is required.");
    }
    const selectedProductsList = products.filter((product) => product.selected);
    if (selectedProductsList.length === 0) {
      errors.push("At least one product must be selected.");
    } else {
      selectedProductsList.forEach((product) => {
        if (!product.brand) {
          errors.push(`Brand must be selected for product: ${product.product_name}.`);
        }
        if (!product.quantity && !product.pieces) {
          errors.push(
            `Either quantity or pieces must be provided for product: ${product.product_name}.`
          );
        } else if (product.quantity && product.pieces) {
          errors.push(
            `Only one of quantity or pieces can be provided for product: ${product.product_name}.`
          );
        } else {
          if (product.quantity && Number(product.quantity) < 0) {
            errors.push(
              `Quantity must be a non-negative number for product: ${product.product_name}.`
            );
          }
          if (product.pieces && Number(product.pieces) < 0) {
            errors.push(
              `Pieces must be a non-negative number for product: ${product.product_name}.`
            );
          }
        }
      });
    }
    if (!formData.payment_terms) {
      errors.push("Payment Terms is required.");
    }
    if (formData.payment_terms && formData.payment_terms.toLowerCase() === "credit") {
      if (!formData.payment_terms_description) {
        errors.push("Number of Days is required when Payment Terms is Credit.");
      } else if (Number(formData.payment_terms_description) < 1) {
        errors.push("Number of Days must be a positive number.");
      }
    }
    if (!formData.delivery_title) {
      errors.push("Delivery Terms is required.");
    }
    if (formData.delivery_title === "Delivered To") {
      if (!formData.delivery_address || !formData.delivery_address.trim()) {
        errors.push("Delivery Address is required when Delivery Terms is Delivered To.");
      }
    }
    if (!formData.delivery_conditions) {
      errors.push("Delivery Conditions is required.");
    }
    if (!formData.delivery_date) {
      errors.push("Delivery Date is required.");
    }
    if (formData.delivery_date === "Immediate") {
      if (!formData.delivery_date_hours) {
        errors.push("Hours is required for Delivery Date: Immediate.");
      } else if (Number(formData.delivery_date_hours) < 1) {
        errors.push("Hours must be a positive number.");
      }
    }
    if (formData.delivery_date === "Within") {
      if (!formData.delivery_date_days) {
        errors.push("Days is required for Delivery Date: Within.");
      } else if (Number(formData.delivery_date_days) < 1) {
        errors.push("Days must be a positive number.");
      }
    }
    return errors;
  };
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateForm();
    if (errors.length > 0) {
      setSnackbar({
        open: true,
        message: errors.join("\n"),
        severity: "error",
      });
      return;
    }
    const transformedData = {
      app_user_id: formData.app_user_id,
      payment_terms: formData.payment_terms,
      payment_terms_description:
        formData.payment_terms.toLowerCase() === "credit"
          ? formData.payment_terms_description
          : null,
      delivery_terms: formData.delivery_title,
      delivery_address: formData.delivery_address,
      delivery_conditions: formData.delivery_conditions,
      delivery_date: formData.delivery_date,
      delivery_date_hours:
        formData.delivery_date === "Immediate" ? formData.delivery_date_hours : null,
      delivery_date_days:
        formData.delivery_date === "Within" ? formData.delivery_date_days : null,
      company_name: formData.company_name,
      contact_person: formData.contact_person,
      email: formData.email,
      mobile: formData.mobile,
      subject: formData.subject,
      message: formData.message,
      status: formData.status,
      products: selectedProducts.map((product) => ({
        product_id: product.id,
        brand_id: product.brand,
        quantity: product.quantity || null,
        pieces: product.pieces || null,
      })),
    };
    try {
      await axios.post(API_ENDPOINTS.CREATE_ENQUIRY, transformedData);
      setSnackbar({
        open: true,
        message: "Enquiry submitted successfully!",
        severity: "success",
      });
      setFormData({
        app_user_id: "",
        payment_terms: "",
        payment_terms_description: "",
        delivery_title: "",
        delivery_address: "",
        delivery_conditions: "",
        delivery_date: "",
        delivery_date_hours: "",
        delivery_date_days: "",
        company_name: "",
        contact_person: "",
        email: "",
        mobile: "",
        subject: "",
        message: "",
        status: "pending",
      });
      setProducts((prev) =>
        prev.map((p) => ({ ...p, selected: false, brand: "", quantity: "", pieces: "" }))
      );
      setSelectedProducts([]);
      navigate("/enquiry-success");
    } catch (error) {
      setSnackbar({
        open: true,
        message: "Error submitting enquiry. Please try again.",
        severity: "error",
      });
    }
  };
  return (
    <div className="app-container enquiry-now-page">
      <Navigation />
     
      <section className="inner-section">
        <div className="home-container">
          <form onSubmit={handleSubmit}>
            <Typography variant="h6" className="enquiry-section-title" sx={{ mb: 2 }}>
              Customer Details
            </Typography>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  label="Company Name"
                  name="company_name"
                  value={formData.company_name}
                  onChange={handleChange}
                  fullWidth
                  required
                  sx={{ mb: 2 }}
                />
              </Grid>
              {/* <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  label="Contact Person Name"
                  name="contact_person"
                  value={formData.contact_person}
                  onChange={handleChange}
                  fullWidth
                  required
                  sx={{ mb: 2 }}
                />
              </Grid> */}
              {/* <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  label="Email Address"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  fullWidth
                  required
                  sx={{ mb: 2 }}
                />
              </Grid> */}
              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  label="Mobile Number"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  fullWidth
                  required
                  sx={{ mb: 2 }}
                  inputProps={{ inputMode: "numeric", pattern: "[0-9]*", maxLength: 10, minLength: 10 }}
                />
              </Grid>
            </Grid>
            <Box className="customer-table">
              <Typography variant="h6" className="enquiry-section-title" sx={{ mb: 2 }}>
                Product Selection
              </Typography>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ width: "8%" }}>Select</TableCell>
                      <TableCell sx={{ width: "23%" }}>Product Name</TableCell>
                      <TableCell sx={{ width: "23%" }}>Brand</TableCell>
                      <TableCell sx={{ width: "23%" }}>Quantity</TableCell>
                      <TableCell sx={{ width: "23%" }}>Pieces</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {products.map((product) => (
                      <TableRow key={product.id}>
                        <TableCell sx={{ width: "8%" }}>
                          <Checkbox
                            checked={product.selected}
                            onChange={() => handleProductSelection(product.id)}
                          />
                        </TableCell>
                        <TableCell sx={{ width: "23%" }}>{product.product_name}</TableCell>
                        <TableCell sx={{ width: "23%" }}>
                          <FormControl fullWidth>
                            <InputLabel id={`brand-label-${product.id}`}>Brand</InputLabel>
                            <Select
                              labelId={`brand-label-${product.id}`}
                              value={product.brand}
                              onChange={(e) =>
                                handleProductFieldChange(product.id, "brand", e.target.value)
                              }
                              disabled={!product.selected}
                            >
                              <MenuItem value="" disabled>
                                Select Brand
                              </MenuItem>
                              {brands.map((brand) => (
                                <MenuItem key={brand.id} value={brand.id}>
                                  {brand.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell sx={{ width: "23%" }}>
                          <TextField
                            type="number"
                            value={product.quantity}
                            onChange={(e) =>
                              handleProductFieldChange(product.id, "quantity", e.target.value)
                            }
                            disabled={!product.selected || product.pieces !== ""}
                            inputProps={{ min: 0 }}
                            label="Quantity"
                            fullWidth
                          />
                        </TableCell>
                        <TableCell sx={{ width: "23%" }}>
                          <TextField
                            type="number"
                            value={product.pieces}
                            onChange={(e) =>
                              handleProductFieldChange(product.id, "pieces", e.target.value)
                            }
                            disabled={!product.selected || product.quantity !== ""}
                            inputProps={{ min: 0 }}
                            label="Pieces"
                            fullWidth
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid size={{ xs: 12, md: 6 }}>
                <Card sx={{ borderWidth: 1, borderStyle: "solid", p: 2, minHeight: 230 }}>
                  <Typography variant="h6" sx={{ mb: 2 }}>
                    Payment Terms
                  </Typography>
                  <FormControl component="fieldset" required>
                    <FormLabel component="legend">Select Payment Term</FormLabel>
                    <RadioGroup
                      name="payment_terms"
                      value={formData.payment_terms}
                      onChange={handleChange}
                    >
                      {paymentTerms.map((term) => (
                        <Box key={term.id}>
                          <FormControlLabel
                            value={term.name}
                            control={<Radio />}
                            label={term.name}
                          />
                          {term.name.toLowerCase() === "credit" &&
                            formData.payment_terms === term.name && (
                              <TextField
                                label="Number of Days"
                                name="payment_terms_description"
                                type="number"
                                value={formData.payment_terms_description}
                                onChange={handleChange}
                                fullWidth
                                sx={{ mt: 1, ml: 4 }}
                                required
                                inputProps={{ min: 1 }}
                              />
                            )}
                        </Box>
                      ))}
                    </RadioGroup>
                  </FormControl>
                </Card>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Card sx={{ borderWidth: 1, borderStyle: "solid", p: 2, minHeight: 230 }}>
                  <Typography variant="h6" sx={{ mb: 2 }}>
                    Delivery Terms
                  </Typography>
                  <FormControl component="fieldset" required>
                    <FormLabel component="legend">Select Delivery Term</FormLabel>
                    <RadioGroup
                      name="delivery_title"
                      value={formData.delivery_title}
                      onChange={handleChange}
                    >
                      {deliveryTerms.map((term) => (
                        <Box key={term.id}>
                          <FormControlLabel
                            value={term.name}
                            control={<Radio />}
                            label={term.name}
                          />
                          {term.name === "Delivered To" &&
                            formData.delivery_title === term.name && (
                              <TextField
                                label="Delivery Address"
                                name="delivery_address"
                                multiline
                                rows={3}
                                value={formData.delivery_address}
                                onChange={handleChange}
                                fullWidth
                                sx={{ mt: 1, ml: 4 }}
                                required
                              />
                            )}
                        </Box>
                      ))}
                    </RadioGroup>
                  </FormControl>
                </Card>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Card sx={{ borderWidth: 1, borderStyle: "solid", p: 2, minHeight: 230 }}>
                  <Typography variant="h6" sx={{ mb: 2 }}>
                    Delivery Conditions
                  </Typography>
                  <FormControl component="fieldset" required>
                    <FormLabel component="legend">Select Delivery Condition</FormLabel>
                    <RadioGroup
                      name="delivery_conditions"
                      value={formData.delivery_conditions}
                      onChange={handleChange}
                    >
                      {deliveryConditionsOptions.map((condition) => (
                        <FormControlLabel
                          key={condition.id}
                          value={condition.name}
                          control={<Radio />}
                          label={condition.name}
                        />
                      ))}
                    </RadioGroup>
                  </FormControl>
                </Card>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Card sx={{ borderWidth: 1, borderStyle: "solid", p: 2, minHeight: 230 }}>
                  <Typography variant="h6" sx={{ mb: 2 }}>
                    Delivery Date
                  </Typography>
                  <FormControl component="fieldset" required>
                    <FormLabel component="legend">Select Delivery Date</FormLabel>
                    <RadioGroup
                      name="delivery_date"
                      value={formData.delivery_date}
                      onChange={handleChange}
                    >
                      {deliveryDateOptions.map((option) => (
                        <Box key={option.id}>
                          <FormControlLabel
                            value={option.name}
                            control={<Radio />}
                            label={option.name}
                          />
                          {option.name === "Immediate" &&
                            formData.delivery_date === option.name && (
                              <TextField
                                label="Hours"
                                name="delivery_date_hours"
                                type="number"
                                value={formData.delivery_date_hours}
                                onChange={handleChange}
                                inputProps={{ min: 1 }}
                                fullWidth
                                sx={{ mt: 1, ml: 4 }}
                                required
                              />
                            )}
                          {option.name === "Within" &&
                            formData.delivery_date === option.name && (
                              <TextField
                                label="Days"
                                name="delivery_date_days"
                                type="number"
                                value={formData.delivery_date_days}
                                onChange={handleChange}
                                inputProps={{ min: 1 }}
                                fullWidth
                                sx={{ mt: 1, ml: 4 }}
                                required
                              />
                            )}
                        </Box>
                      ))}
                    </RadioGroup>
                  </FormControl>
                </Card>
              </Grid>
            </Grid>
            <Box mt={3} sx={{ textAlign: "center" }}>
              <Button type="submit" className="large-button" variant="contained" color="primary">
                Send Enquiry
              </Button>
            </Box>
            <Snackbar
              open={snackbar.open}
              autoHideDuration={6000}
              onClose={() => setSnackbar({ ...snackbar, open: false })}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <Alert
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                severity={snackbar.severity}
                sx={{ width: "100%", whiteSpace: "pre-line" }}
              >
                {snackbar.message}
              </Alert>
            </Snackbar>
          </form>
        </div>
      </section>
      <FrontendFooter />
    </div>
  );
};
export default EnquiryNow;